import { render, staticRenderFns } from "./CreateAgeGroupReport.vue?vue&type=template&id=ce1652a8&scoped=true"
import script from "./CreateAgeGroupReport.vue?vue&type=script&lang=js"
export * from "./CreateAgeGroupReport.vue?vue&type=script&lang=js"
import style0 from "./CreateAgeGroupReport.vue?vue&type=style&index=0&id=ce1652a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1652a8",
  null
  
)

export default component.exports